import PropTypes from 'prop-types';
import React from "react";
import Relay from "react-relay"
import { browserHistory } from "react-router"
import Icon from "./Icon"
import AddToSet from "../modules/AddToSet"
import State from "../../stores/State"
import Popover from "react-bootstrap/lib/Popover"
import OverlayTrigger from "react-bootstrap/lib/OverlayTrigger"
import shareMessages from "../../messages/share"
import { injectIntl } from "react-intl"

export class AddFavourite extends React.Component {
  static propTypes = {
    iconStyle: PropTypes.string,
    resource: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired
  }

  state = {
    isLoggedIn: State.get("loggedIn")
  }

  componentDidMount() {
    this._stateListener = State.addListener(() => {
      const isLoggedIn = State.get("loggedIn")
      if (isLoggedIn !== this.state.isLoggedIn) {
        this.setState({
          isLoggedIn: isLoggedIn
        })
      }
    })
  }

  componentWillUnmount() {
    if (this._stateListener) this._stateListener.remove()
  }

  closePopover = () => {
    this.refs.popover.hide()
  }

  render() {
    const { iconStyle, resource, viewer, intl, className } = this.props
    const isFavourite =
      resource && resource.favourite && resource.favourite.favourite
    const iconSuffix = iconStyle ? "-" + iconStyle : ""
    const { isLoggedIn } = this.state

    return (
      <span>
        {!isLoggedIn && (
          <button
            type="button"
            onClick={e =>
              browserHistory.push(`/login?next=/item/${resource.id}`)
            }
            title={intl.formatMessage(shareMessages.addToSet)}
            className={className}
          >
            <Icon
              icon={
                isFavourite ? "heart-check" + iconSuffix : "heart" + iconSuffix
              }
            />
          </button>
        )}

        {isLoggedIn && (
          <OverlayTrigger
            trigger="click"
            rootClose={true}
            placement="top"
            ref="popover"
            shouldUpdatePosition={true} // this prop needs to be on trigger AND popover
            overlay={
              <Popover
                title={intl.formatMessage(shareMessages.addToSet)}
                id="popover-add-to-set"
                shouldUpdatePosition={true}
              >
                <AddToSet
                  resource={resource}
                  viewer={viewer}
                  onClose={this.closePopover}
                />
              </Popover>
            }
          >
            <button
              type="button"
              title={
                isFavourite
                  ? intl.formatMessage(shareMessages.addRemoveFromSet)
                  : intl.formatMessage(shareMessages.addToSet)
              }
              className={className}
            >
              <Icon
                icon={
                  isFavourite
                    ? "heart-check" + iconSuffix
                    : "heart" + iconSuffix
                }
              />
            </button>
          </OverlayTrigger>
        )}
      </span>
    )
  }
}

export default Relay.createContainer(injectIntl(AddFavourite), {
  fragments: {
    resource: () => Relay.QL`
      fragment on Resource {
        id
        favourite {
          favourite
        }
        ${AddToSet.getFragment("resource")}
      }
    `,
    viewer: () => Relay.QL`
      fragment on Viewer {
        ${AddToSet.getFragment("viewer")}
      }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/elements/AddFavourite.js